export enum EditorType {
  html = 0,
  odt = 1
}
